import { render, staticRenderFns } from "./EditAssetMeta.vue?vue&type=template&id=25f70b9e"
import script from "./EditAssetMeta.vue?vue&type=script&lang=js"
export * from "./EditAssetMeta.vue?vue&type=script&lang=js"
import style0 from "./EditAssetMeta.vue?vue&type=style&index=0&id=25f70b9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports